import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatMenuPanel } from '@angular/material/menu';


@Component({
    selector: 'item-list-header',
    templateUrl: './item-list-header.component.html',
    styleUrls: ['./item-list-header.component.scss'],
    standalone: false
})
export class ItemListHeaderComponents {
  @Input() hasSelectedItems: boolean = false;
  @Input() allItemsSelected: boolean = false;
  @Input() indeterminate = false;

  @Input() showAvailable: boolean = true;
  @Input() hideAvailable: boolean = true;
  @Input() shareAvailable: boolean = true;
  @Input() shareOffAvailable: boolean = true;
  @Input() moreAvailable: boolean = true;
  @Input() moreMenu: MatMenuPanel<any> | null = null

  @Input() disableShow: boolean = false;
  @Input() disableHide: boolean = false;

  @Output() allCheckboxStateChanged: EventEmitter<boolean> = new EventEmitter();

  @Output() clickShow: EventEmitter<void> = new EventEmitter();
  @Output() clickHide: EventEmitter<void> = new EventEmitter();
  @Output() clickShare: EventEmitter<void> = new EventEmitter();
  @Output() clickShareOff: EventEmitter<void> = new EventEmitter();

  onAllCheckboxStateChange(event: any): void {
    this.allCheckboxStateChanged.next(event.checked);
  }
}
